export  const BASE_URL = "https://cos-backend.cambridgeonlineschool.org";
export const fileTextBookUrl = 'https://cos-backend.cambridgeonlineschool.org/Uploads/TextBooks/'
export const Login = 'api/Login';

export const headerToken = localStorage.getItem("user")
export const token  = JSON.parse(headerToken);

